import React from "react";
import ServiceEditorModal from "./";
import { useAtomValue } from "jotai/utils";
import {
  globalServiceEditorPropsAtom,
  useCloseGlobalServiceEditor,
} from "./atoms/globalModal";
import { useMasterId } from "@/hooks/useMasterId";
import { useTranslation } from "react-i18next";

const GlobalServiceEditorModal = () => {
  const { t, ready: tReady } = useTranslation(["common", "errors"], {
    useSuspense: false,
  });
  const authMasterId = useMasterId();
  const props = useAtomValue(globalServiceEditorPropsAtom);
  const close = useCloseGlobalServiceEditor();
  const masterId = props.masterId || authMasterId;
  if (!tReady) return null;
  return (
    <ServiceEditorModal
      {...props}
      masterId={masterId}
      onClose={close}
      isOpen={props.isOpen && Boolean(masterId)}
      t={t}
    />
  );
};

export default GlobalServiceEditorModal;
